import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { useMobileOnly } from '../../../../helpers/responsive';
import BottomDrawer from '../../../BottomDrawer/BottomDrawer';
import Modal from '../../../Modal/Modal';
import useClickOutside from '../../../../helpers/useClickOutside';
import styles from './assets/styles.scss';
import { assetIcons } from '../../../../config';
import useTableDeposit from './useTableDeposit';
import Deposit from './Deposit';
import { useGameStore } from '../../../Game/hooks/useGameStore';
import Info from './Info';

import IconInfo from '../../../../games/assets/images/icon-info-round.svg?inline';
import IconArrowBack from './assets/arrow-back.svg?inline';
import IconPlus from '../../../../assets/img/plus-square.svg?inline';
import useAppStore from '../../../../useAppStore';

const cx = classNames.bind(styles);

export default function GameBalance() {
  const isMobileOnly = useMobileOnly();
  const drawerRef = useRef(null);
  const buttonRef = useRef(null);
  const [isInfo, setIsInfo] = useState(false);
  const { depositBalance } = useTableDeposit();
  const bettingDisabled = useGameStore(state => state.bettingDisabled);

  const isOpen = useAppStore(state => state.showDepositModal);
  const setIsOpen = useAppStore.getState().setShowDepositModal;

  useEffect(() => {
    if (!isOpen) {
      setIsInfo(false);
    }
  }, [isOpen]);

  useClickOutside(() => {
    setIsOpen(false);
  }, [drawerRef, buttonRef]);

  useEffect(() => {
    const { socket } = useAppStore.getState();

    socket.on('LOW_BALANCE', () => {
      setIsOpen(true);
    });
  }, []);

  const header = isInfo ? (
    <div className={cx('info-header', 'header')}>
      <button
        type="button"
        aria-label="Back"
        onClick={e => {
          setIsInfo(false);
          e.stopPropagation();
        }}
      >
        <IconArrowBack />
      </button>
      <h4>What is Game Balance?</h4>
    </div>
  ) : (
    <div className={cx('deposit-header', 'header')}>
      <h4>Game Balance Deposit</h4>
      <button
        type="button"
        aria-label="Close"
        onClick={e => {
          setIsInfo(true);
          e.stopPropagation();
        }}
      >
        <IconInfo />
      </button>
    </div>
  );

  const content = isInfo ? <Info goBack={() => setIsInfo(false)} /> : <Deposit closeModal={() => setIsOpen(false)} />;

  return (
    <>
      <button type="button" className={cx('game-balance', 'bold')} onClick={() => setIsOpen(!isOpen)} ref={buttonRef}>
        <span className={cx('bold')}>{depositBalance?.toNumber() || '0.0000'}</span>
        {assetIcons.BSV({})}
        BSV
        <IconPlus />
      </button>
      {isMobileOnly ? (
        <BottomDrawer isOpen={isOpen} className={cx('mobile-drawer')} ref={drawerRef} unmountOnClose={false}>
          {header}
          {content}
        </BottomDrawer>
      ) : (
        <Modal
          isOpen={isOpen}
          onClose={() => !bettingDisabled && setIsOpen(false)}
          header={header}
          modalClassName={cx('modal')}
          unmountOnClose={false}
        >
          {content}
        </Modal>
      )}
    </>
  );
}

GameBalance.propTypes = {};
GameBalance.defaultProps = {};
